import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

// Create an async thunk for fetching data
// export const fetchClientData = createAsyncThunk(
//   "clients/fetchClientData",
//   async (filterPayload, { rejectWithValue }) => {
//     try {
//       console.log("filterPayload ==>", filterPayload);

//       const response = await axiosInstance.post("/dm/influencer_list", filterPayload);
//       return {
//         status_id: filterPayload.status_id,
//         data: response.data,
//       };
//     } catch (err) {
//       return rejectWithValue(err.response.data);
//     }
//   },
// );

export const fetchClientData = createAsyncThunk(
  "clients/fetchClientData",
  async (filterPayload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/dm/influencer_list",
        filterPayload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchClientFilteredData = createAsyncThunk(
  "clients/fetchClientFilteredData",
  async ({ status_id, page, limit }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/dm/influencer_list", {
        status_id,
        page,
        limit,
      });
      return { status_id, data: response.data };
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const influencerRegisterData = createAsyncThunk(
  "clients/influencerRegisterData",
  async (userDetails, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/influencer/add_influencer", userDetails);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

// export const fetchInfluencerData = createAsyncThunk(
//   "clients/fetchInfluencerData",
//   async (inf_id, { rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.post("/dmexe/inf_details_for_edit", {
//         inf_id
//       });
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

export const clientRequestInf = createAsyncThunk(
  "clients/clientRequestInf",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/dmexe/request_influencer",
        formData,
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const fetchInfluencerData = createAsyncThunk(
  "clients/fetchInfluencerData",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/dmexe/inf_details_for_edit",
        formData,
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

const initialClientState = {
  data: [],
  pagination: {
    limit: 0,
    page: 0,
    totalItems: 0,
    totalPages: 0,
  },
};

const influencerSlice = createSlice({
  name: "clients",
  initialState: {
    clientData: initialClientState,
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientData.pending, (state) => {
        state.status = "loading";
      })

      .addCase(fetchClientData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.clientData = action.payload;
      })

      .addCase(fetchClientData.rejected, (state, action) => {
        state.status = "failed";

        state.error = action.payload;
      })
      .addCase(fetchClientFilteredData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchClientFilteredData.fulfilled, (state, action) => {
        const { status_id, data } = action.payload;
        state.status = "succeeded";
        if (status_id === "1") {
          state.activeClientData = data;
        } else if (status_id === "0") {
          state.pendingClientData = data;
        } else if (status_id === "4") {
          state.inactiveClientData = data;
        } else if (status_id === "99") {
          state.allClientData = data;
        } else if (status_id === "5") {
          state.assignedClientData = data;
        }
      })
      .addCase(fetchClientFilteredData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(clientRequestInf.pending, (state) => {
        state.status = "loading";
      })
      .addCase(clientRequestInf.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.clientInfluencerRequest = action.payload;
      })
      .addCase(clientRequestInf.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // .addCase(influencerRegisterData.pending, (state) => {
      //   state.status = "loading";
      // })
      // .addCase(influencerRegisterData.fulfilled, (state, action) => {
      //   state.status = "succeeded";
      //   state.clientInfluencerRequest = action.payload;
      // })
      // .addCase(influencerRegisterData.rejected, (state, action) => {
      //   state.status = "failed";
      //   state.error = action.payload;
      // })
      ;
  },
});

export default influencerSlice.reducer;
